import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldAlert, ExternalLink, RefreshCw } from 'lucide-react';

const SubscriptionModal = ({ missingChannels, onVerify }) => {
    return (
        <AnimatePresence>
            <motion.div
                className="fixed inset-0 flex items-center justify-center z-50 p-4"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)', backdropFilter: 'blur(5px)' }}
            >
                <motion.div
                    className="bg-[#1a1d24] rounded-2xl w-full max-w-md shadow-2xl overflow-hidden border border-gray-800"
                    initial={{ scale: 0.9, y: 20 }}
                    animate={{ scale: 1, y: 0 }}
                    transition={{ type: 'spring', damping: 25, stiffness: 300 }}
                >
                    <div className="p-6 text-center">
                        <div className="mx-auto w-16 h-16 bg-blue-500/10 rounded-full flex items-center justify-center mb-4 text-blue-400">
                            <ShieldAlert size={32} />
                        </div>
                        <h2 className="text-xl font-bold text-white mb-2">الاشتراك الإجباري</h2>
                        <p className="text-gray-400 text-sm mb-6">
                            عذراً، يجب عليك الاشتراك في جميع القنوات التالية للتمكن من استخدام ميزات التطبيق.
                        </p>

                        <div className="space-y-3 mb-6 max-h-48 overflow-y-auto pr-1 custom-scrollbar">
                            {missingChannels.map((channel, idx) => (
                                <div key={idx} className="flex items-center justify-between bg-[#12141a] p-3 rounded-xl border border-gray-800/50">
                                    <span className="text-gray-200 text-sm font-medium" dir="ltr">{channel.id}</span>
                                    <a
                                        href={channel.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
                                    >
                                        <span>اشتراك</span>
                                        <ExternalLink size={14} />
                                    </a>
                                </div>
                            ))}
                        </div>

                        <button
                            onClick={onVerify}
                            className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-3 rounded-xl font-medium flex items-center justify-center gap-2 transition-colors"
                        >
                            <RefreshCw size={18} />
                            <span>تحقق من الاشتراك</span>
                        </button>
                    </div>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};

export default SubscriptionModal;
